module.exports = __webpack_public_path__ + "static/media/camera.19a11ad3.svg";